import { NavyDamageType, NavyDamageTypeCategory } from './types'

export const navyDamageCategories: NavyDamageTypeCategory[] = [
  {
    id: 'corrosion',
    label: 'Corrosion',
    types: [
      {
        id: 'corrosion-general-rust',
        label: 'General / Surface Rust',
        navyProperty: 'corrosionGeneralRust',
      },
      {
        id: 'corrosion-scaling',
        label: 'Scaling / Exfoliation',
        navyProperty: 'corrosionScaling',
      },
      {
        id: 'corrosion-pitting',
        label: 'Pitting',
        navyProperty: 'corrosionPitting',
      },
      {
        id: 'corrosion-grating-support',
        label: 'Grating Support Structure Corroded',
        navyProperty: 'corrosionGratingSupport',
      },
      {
        id: 'corrosion-equipment-foundation',
        label: 'Equipment Foundation Corroded',
        navyProperty: 'corrosionEquipmentFoundation',
      },
      {
        id: 'corrosion-other',
        label: 'Other (Explain in Comments)',
        navyProperty: 'corrosionOther',
      },
    ],
  },
  {
    id: 'structural',
    label: 'Structural',
    types: [
      {
        id: 'structural-holing',
        label: 'Holing',
        navyProperty: 'structuralHoling',
      },
      {
        id: 'structural-weld-crack',
        label: 'Weld Crack / Separation',
        navyProperty: 'structuralWeldCrack',
      },
      {
        id: 'structural-buckling',
        label: 'Buckling / Distortion',
        navyProperty: 'structuralBuckling',
      },
      {
        id: 'structural-doubler-plate',
        label: 'Doubler Plate Installed / Damaged',
        navyProperty: 'structuralDoublerPlate',
      },
      {
        id: 'structural-plate-crack',
        label: 'Plate / Stiffener Crack',
        navyProperty: 'structuralPlateCrack',
      },
      {
        id: 'structural-dent-crease',
        label: 'Local Dent / Crease',
        navyProperty: 'structuralDentCrease',
      },
      {
        id: 'structural-foundation-damaged',
        label: 'Equipment Foundation Damaged / Cracked',
        navyProperty: 'structuralFoundationDamaged',
      },
      {
        id: 'structural-grating-damaged',
        label: 'Grating Support Damaged',
        navyProperty: 'structuralGratingDamaged',
      },
      {
        id: 'structural-stanchion-damaged',
        label: 'Stanchion Damaged',
        navyProperty: 'structuralStanchionDamaged',
      },
      {
        id: 'structural-drainage',
        label: 'Lack of Drainage / Air Escape Openings',
        navyProperty: 'structuralDrainage',
      },
      {
        id: 'structural-unacceptable-pitting',
        label: 'Unacceptable Pitting',
        navyProperty: 'structuralUnacceptablePitting',
      },
      {
        id: 'structural-other',
        label: 'Other Damage (Explain in Comments)',
        navyProperty: 'structuralOther',
      },
    ],
  },
]

export const getAllNavyDamageTypes = (): NavyDamageType[] => {
  return navyDamageCategories.flatMap(
    (category) => category.types as NavyDamageType[]
  )
}

export const getNavyDamageTypeById = (
  id: string
): NavyDamageType | undefined => {
  return getAllNavyDamageTypes().find((type) => type.id === id)
}

export const getNavyCategoryForDamageType = (
  damageTypeId: string
): string | null => {
  for (const category of navyDamageCategories) {
    if (category.types.some((type) => type.id === damageTypeId)) {
      return category.id
    }
  }
  return null
}
